if (!customElements.get("collection-tabs")) {
	class CollectionTabs extends HTMLElement {
		constructor() {
			super();
			this.selectors = {
				images: [".tabs__image"],
				collapsibleTabs: ["collapsible-tab"],
			};
		}

		init() {
			this.domNodes = queryDomNodes(this.selectors, this);
			this.tabActiveIndex = 0;
			this.totalTabs = (this.domNodes.collapsibleTabs || []).length;

			this.hoverToOpen =
				this.dataset.triggerBehavior === "hover" &&
				window.matchMedia("(hover: hover)").matches;
			this._unsubOpened = null;
			this._unsubSelected = null;
			this._onMouseEnter = this.onMouseEnterCollapsibleTabs.bind(this);
		}

		connectedCallback() {
			this.init();
			if (!this.totalTabs) return;

			this._unsubOpened = this.subscribeThemeEvent(
				"ON_COLLAPSIBLE_TAB_OPENED",
				(collapsibleTab) => {
					if (!collapsibleTab?.classList?.contains("collection-tab")) return;
					const collectionTabs = collapsibleTab.closest("collection-tabs");
					collectionTabs && collectionTabs.onTabOpened(collapsibleTab);
				}
			);

			this._unsubSelected = this.subscribeThemeEvent(
				"ON_COLLAPSIBLE_TAB_SELECTED",
				(collapsibleTab) => {
					if (!collapsibleTab?.classList?.contains("collection-tab")) return;
					const collectionTabs = collapsibleTab.closest("collection-tabs");
					collectionTabs && collectionTabs.onElementSelected(collapsibleTab);
				}
			);

			if (this.hoverToOpen) {
				this.domNodes.collapsibleTabs.forEach((tab) => {
					tab.addEventListener("mouseenter", this._onMouseEnter);
				});
			}
		}

		subscribeThemeEvent(eventName, cb) {
			const bus = window.ThemeEvents;

			if (bus && typeof bus.subscribe === "function") {
				return bus.subscribe(eventName, cb);
			}

			const handler = (e) => cb(e.detail);
			document.addEventListener(eventName, handler);

			return () => document.removeEventListener(eventName, handler);
		}

		onElementSelected(collapsibleTab) {
			if (!this.domNodes.images) return;

			this.domNodes.images.forEach((image, index) => {
				if (collapsibleTab.dataset.blockId === image.dataset.blockId) {
					this.tabActiveIndex = index;
					image.classList.add("is-active");
				} else {
					image.classList.remove("is-active");
				}
			});
		}

		onMouseEnterCollapsibleTabs(event) {
			const tab = event.currentTarget;
			tab?.open?.();
		}

		disconnectedCallback() {
			this._unsubOpened && this._unsubOpened();
			this._unsubSelected && this._unsubSelected();

			if (this.hoverToOpen && this._onMouseEnter) {
				this.domNodes.collapsibleTabs.forEach((tab) => {
					tab.removeEventListener("mouseenter", this._onMouseEnter);
				});
			}
		}
	}

	customElements.define("collection-tabs", CollectionTabs);
}
